import {useState} from "react";
import * as lscache from "lscache";

import {useLockBodyScroll} from "@pg-mono/hooks";

const REELS_SEEN = "reelsSeen";

export const useReelsSeen = () => {
    const [reelsPresentationActive, setReelsPresentationActive] = useState<boolean>(false);
    const reelsAlreadySeen = lscache.get(REELS_SEEN);

    useLockBodyScroll(reelsPresentationActive ?? false);

    const activeReelsPresentation = () => {
        if (!reelsAlreadySeen) {
            setReelsPresentationActive(true);
        }
    };

    const closeReelsPresentation = () => {
        setReelsPresentationActive(false);
        lscache.set(REELS_SEEN, true);
    };

    return {reelsPresentationActive, activeReelsPresentation, reelsAlreadySeen, closeReelsPresentation};
};
import {useState} from "react";
import * as lscache from "lscache";

import {useLockBodyScroll} from "@pg-mono/hooks";

const REELS_SEEN = "reelsSeen";

export const useReelsSeen = () => {
    const [reelsPresentationActive, setReelsPresentationActive] = useState<boolean>(false);
    const reelsAlreadySeen = lscache.get(REELS_SEEN);

    useLockBodyScroll(reelsPresentationActive ?? false);

    const activeReelsPresentation = () => {
        if (!reelsAlreadySeen) {
            setReelsPresentationActive(true);
        }
    };

    const closeReelsPresentation = () => {
        setReelsPresentationActive(false);
        lscache.set(REELS_SEEN, true);
    };

    return {reelsPresentationActive, activeReelsPresentation, reelsAlreadySeen, closeReelsPresentation};
};
